import React from 'react';
import { FormattedMessage, InjectedIntl, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { COLORS, MQS } from '../constants/styles';
import { IErrorMessage } from './errorMessage/errorMessage.type';

interface ILabelProps extends React.HTMLAttributes<HTMLLabelElement> {
    fixed?: boolean;
    intl: InjectedIntl;
    labelMessage: FormattedMessage.MessageDescriptor | string;
    required?: boolean;
    htmlFor?: string;
    error?: IErrorMessage | boolean;
    children?: React.ReactNode;
}

interface ILabelElementProps {
    fixed: boolean;
    error?: IErrorMessage | boolean;
}

const LabelElement = styled.label`
    color: ${({ error }) => (error ? COLORS.redTitle + ' !important' : COLORS.grey7)};
    font-size: ${(props: ILabelElementProps) => (props.fixed ? '0.875rem' : '1rem')};
    pointer-events: none;
    position: absolute;
    top: -25px;
    padding-left: 0.6rem;
    transition: all 0.1s ease-in-out;
    font-size: 0.875rem;
`;

const Label = ({
    children = null,
    fixed = true,
    intl,
    labelMessage,
    required,
    error,
    ...rest
}: ILabelProps) => {
    const label = TranslationHelpers.isMessageDescriptor(labelMessage)
        ? TranslationHelpers.getFormattedMessage(labelMessage.id)
        : labelMessage;

    const optionalTranslated = intl.formatMessage(
        TranslationHelpers.getMessageDescriptor('label.optional'),
    );
    const requireIndicator =
        typeof required !== 'undefined' ? (required ? ' *' : ` ${optionalTranslated}`) : '';

    return (
        <LabelElement fixed={fixed} error={error} {...rest}>
            {label}
            {requireIndicator}
            {children}
        </LabelElement>
    );
};

export default injectIntl(Label);
